import React from 'react';
import './CTA.css';

const SecondaryCTA = ({ 
  children, 
  href, 
  onClick, 
  className = '', 
  ariaLabel,
  icon = '✉',
  target,
  rel
}) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <a 
      href={href} 
      onClick={handleClick}
      className={`cta cta--secondary ${className}`}
      aria-label={ariaLabel}
      role="button"
      target={target}
      rel={rel}
    >
      <span>{children}</span>
      <span className="cta__icon" aria-hidden="true">{icon}</span>
    </a>
  );
};

export default SecondaryCTA;
